import { RefObject, Ref, RefCallback } from 'react';

export function mergeRefs<T extends Element>(refs: Array<Ref<T> | undefined | null>): RefCallback<T> {
  return (value) => {
    refs.forEach((ref) => {
      if (typeof ref === 'function') {
        ref(value);
      } else if (ref != null) {
        (ref as RefObject<T | null>).current = value;
      }
    });
  };
}
